// 区分正式环境和测试环境、本地部署环境、本地开发环境
const getTokenPreFix = () => {
  switch (import.meta.env.VITE_STAGE) {
    case 'development':
      return 'DEV_';
    case 'pre':
      return 'PRE_';
    case 'local_deploy':
      return 'LOCAL_';
    case 'internet':
      return 'INTERNET_';
    case 'production':
    default: {
      return '';
    }
  }
};
const TOKEN_PREFIX = getTokenPreFix();

// token 值 `toekn_type + access_token`
export const KEY_MYGPT_TOKEN = TOKEN_PREFIX + 'MY_GPT_TOKEN';

// token 过期时间
export const KEY_MYGPT_TOKEN_EXPIRESIN = TOKEN_PREFIX + 'MY_GPT_TOKEN_EXPIRESIN';

// refrsh token 值
export const KEY_MYGPT_REFRESH_TOKEN = TOKEN_PREFIX + 'KEY_MYGPT_REFRESH_TOKEN';

// chat 对话历史
export const KEY_MYGPT_COMPLETIONS = 'MY_GPT_COMPLETIONS';

// 存储登录前的pathName
export const KEY_MYGPT_PATH_NAME = 'MY_GPT_PATH_NAME';

// 多语言
export const KEY_TRANSLATE_LANGUAGE = 'MY_GPT_LANGUAGE';
